import Param from '../../param';
import effectManager from '../effect';
import Pararax from './pararax';
import ScrollAnimation from './scrollanimation';
import Contents from './contents';

let param = new Param();
let scrollAnimation;
let contents;
let effect = new effectManager();

export default class smoothScrollManager{
    constructor(pageID){

        this.pararax = new Pararax();
        scrollAnimation = new ScrollAnimation(pageID);
        contents = new Contents();

        this.w = $(window).innerWidth();
        this.h = $(window).innerHeight();

        this.$htmlBody = $("html,body");
        this.$container = $("#l-scroll");
        this.$body = $("#l-scroll-body");
        this.$contents = $("#l-body")
        /* 臨時 */
        this.$kv = $("#p-kv"); // [ TOPのKVアニメーション用 ]
        this.$bodyBg = $("#l-body-bg");
        this.bodyBgSetFlg = false;
        this.kvFlg = false;
        this.$root = $("#l-root");
        this.$scrollDown = $("#c-scrolldown");
        this.$naviLink = $("#l-header-navi-content >* >*");
        this.$progressBar = $("#l-progressbar-gauge");
        this.$footer = $("#l-footer");

        this.flg = false;

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";

        this.paraPoint = [];

        this.scrollLimit = 0; // scroll limit

        this.timer = [];

        this.type = "normal";

        this.inertia = (Useragnt.mobile||Useragnt.tablet)?false:true; /* 慣性スクロールを有効にするか */

        this.pageKvOutFlg = false;


        /* 状態監視用のフラグ */
        this.status = {
            controll : false, /* ページャーなどで操作しているか */
            comp     : false, /* 慣性スクロールが完了したか */
            section  :{
                 offset : [],
            },
            stop : false /* trueの場合スクロールさせない */
        }

        this.webglStop = false; /* KVが画面外なら止める */

        /* 臨時　モーダル用 */
        this.modalStatus = {
            saveInc : 0
        }
        this.scActiveFlg = false; /* ボディより手前にするclassをつけたか */

        if($("body#top")[0]){
            param.scrollType = 'x';
        }else{
            param.scrollType = 'y';
        }

    }
    init(pageID){

        this.$htmlBody = $("html,body");
        this.$container = $("#l-scroll");
        this.$body = $("#l-scroll-body");
        this.$contents = $("#l-body");

        /* 臨時 */
        this.$kv = $("#p-kv"); // [ TOPのKVアニメーション用 ]
        this.$bodyBg = $("#l-body-bg");
        this.$root = $("#l-root");
        this.$scrollDown = $("#c-scrolldown");
        this.$naviLink = $("#l-header-navi-content >* >*");
        this.$progressBar = $("#l-progressbar-gauge");
        this.bodyBgSetFlg = false;
        this.kvFlg = false;
        this.$footer = $("#l-footer");

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";

        this.paraPoint = [];
        this.scrollLimit = 0; // scroll limit
        this.timer = [];
        this.type = "normal";

        if($("body#top")[0]){
            param.scrollType = 'x';
        }else{
            param.scrollType = 'y';
        }

        let _this = this;

        this.pararax.init(param.displayType,param.scrollType);
        scrollAnimation.init(pageID);
        contents.init();
        if(!this.inertia) $("body").addClass("is-inertia-none");

        /* pager操作 */
        this.$naviLink.on("click",function(){
            if($(this)[0]['localName'] === 'a' || $(this)[0].classList.contains('js__modal-trigger')) return;
            let _target = $(this).data("target");
            _this.pager(_target);
        });

        $(".js__modal-trigger").on("click",function(){
            let _select = $(this).data("modal");
            if(_select == 'news') return;
            let _inc = (_select!=="company")?
                    Useragnt.tablet ? _this.inc:_this.inc + $("#p-"+_select+"-rental").offset().left-100:
                    Useragnt.tablet ? _this.inc:_this.inc + $("#p-"+_select).offset().left+(_this.w*0.1);

            _this.modalStatus.saveInc = _this.inc;
            if(Useragnt.tablet)
                _this.$htmlBody.animate({ scrollLeft:_inc  }, '1');
            else
                _this.$htmlBody.animate({ scrollTop:_inc  }, '1');
        });
        $(".l-modal").on("click",function(){
            if(Useragnt.tablet)
                _this.$htmlBody.animate({ scrollLeft:_this.modalStatus.saveInc  }, '1');
            else
                _this.$htmlBody.animate({ scrollTop:_this.modalStatus.saveInc  }, '1');
        });
        $("#l-scrolldown").on("click",function(){

            let _inc = 0;

            for(let i=0; i<_this.status.section.offset.length; i++){
                if(_this.status.section.offset[i]>_this.inc+1){
                    _inc = _this.status.section.offset[i];
                    break;
                }
            }

            if(Useragnt.tablet)
                _this.$htmlBody.animate({ scrollLeft: _inc!==0?_inc:_this.status.section.offset[_this.status.section.offset.length-1] }, '1');
            else
                _this.$htmlBody.animate({ scrollTop: _inc!==0?_inc:_this.status.section.offset[_this.status.section.offset.length-1] }, '1');

        });
        $("#c-scrolldown").on("click",function(){
            _this.$htmlBody.animate({ scrollTop: _this.$kv.innerHeight() + 1 }, '1');
        });
        $("#l-pagetop").on("click",function(){
            if(Useragnt.tablet)
                _this.$htmlBody.animate({ scrollLeft: 0 }, '1');
            else
                _this.$htmlBody.animate({ scrollTop: 0 }, '1');
        });
        $("#c-pagetop").on("click",function(){
            _this.$htmlBody.animate({ scrollTop: 0 }, '1');
        });
        $("#l-header-logo a").on("click",function(){
            if(param.scrollType === 'y') return;
            if(Useragnt.tablet)
                _this.$htmlBody.animate({ scrollLeft: 0 }, '1');
            else
                _this.$htmlBody.animate({ scrollTop: 0 }, '1');

            return false;

        });

    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */

        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        // this.prevInc = this.inc;
        this.mode = "scroll";
        this.status.comp = false;
    }
    move(fpsRate) {

        let add = (this.inertia) ? fpsRate>1.5? 0.08:0.1:0.1;

        this.nowInc +=  add * (this.inc - this.nowInc)*fpsRate;
        if(!this.status.comp) this.trans();

    }
    trans(pageID) {

        if(this.nowInc>1){
            if(!this.scActiveFlg){
                this.scActiveFlg = true;
                this.$container.addClass("is-active")
            }
        }else{
            if(this.scActiveFlg){
                this.scActiveFlg = false;
                this.$container.removeClass("is-active")
            }
        }

        if(this.inertia){
            if(param.displayType === 'sp' || param.scrollType === 'y'){
                TweenMax.set(this.$body,{y:-this.nowInc});
                if(this.h>this.nowInc){
                    if($('body#top')[0])
                        TweenMax.set(this.$kv,{y:-this.nowInc});
                    if(!this.bodyBgSetFlg){
                        this.bodyBgSetFlg=true;
                        this.$bodyBg.removeClass("is-current")
                    }
                }else{
                    if(this.bodyBgSetFlg) {
                        this.bodyBgSetFlg = false;
                        this.$bodyBg.addClass("is-current")
                    }
                }
            }else{
                if(Useragnt.pc)TweenMax.set(this.$body,{x:-this.nowInc});
                if(this.w>this.nowInc){
                    if($('body#top')[0])
                        TweenMax.set(this.$kv,{x:-this.nowInc});
                    if(!this.bodyBgSetFlg){
                        this.bodyBgSetFlg=true;
                        this.$bodyBg.removeClass("is-current")
                    }
                }else{
                    if(this.bodyBgSetFlg) {
                        this.bodyBgSetFlg = false;
                        this.$bodyBg.addClass("is-current")
                    }
                }
                TweenMax.set(this.$progressBar,{x:-100+((this.nowInc/(this.$root.innerHeight()-this.w))*100)+"%"});
            }

        }else{
            if(Useragnt.tablet && param.scrollType === 'x'){
                TweenMax.set(this.$progressBar,{x:-100+((this.nowInc/(this.$root.innerHeight()-this.w))*100)+"%"});
                if(this.w>this.nowInc){
                    TweenMax.set(this.$kv,{x:-this.nowInc});
                    if(!this.bodyBgSetFlg){
                        this.bodyBgSetFlg=true;
                        this.$bodyBg.removeClass("is-current")
                    }
                }else{
                    if(this.bodyBgSetFlg) {
                        this.bodyBgSetFlg = false;
                        this.$bodyBg.addClass("is-current")
                    }
                }
            }
        }
        /* スクロール連動で動作 */

        this.pararax.check(this.nowInc,this.dir);
        contents.update(this.nowInc);

        /* アニメーション対象の要素があるかチェック */
        scrollAnimation.check(
            this.nowInc,
            this.w,
        );


        /* TOP KV動作制御 */

        if(this.nowInc>10){
            if(!this.kvFlg){
                this.kvFlg = true;
                // effect.splitText(this.$kv.find(".js__split-text >* >*"),"out");
            }
        }else{
            if(this.kvFlg){
                this.kvFlg = false;
                // effect.splitText(this.$kv.find(".js__split-text >* >*"),"show");
            }

        }

        /* TOP KV動作制御 END */

        if(this.prevInc > this.nowInc-0.1&&this.dir==="next"||this.prevInc < this.nowInc-0.1&&this.dir==="prev"){
            this.onComplete();
        }
        this.prevInc = this.nowInc;
    }

    pager($target){

        let _this = this;

        let _select = $target;
        let _inc;

        if(param.displayType === 'sp' || param.scrollType === 'y'){
            _inc = $("#p-"+_select).offset().top;
        }else{
            _inc = (Useragnt.tablet)?$("#p-"+_select).offset().left: _this.inc + $("#p-"+_select).offset().left;
        }
        if(Useragnt.tablet){
            _this.$htmlBody.animate({ scrollLeft:_inc  }, '1');
        }else{
            _this.$htmlBody.animate({ scrollTop:_inc  }, '1');
        }

    }
    resize (pageID) {

        if(this.$root.hasClass("is-modal-open") || this.status.stop) return;
        this.w = $(window).innerWidth();
        this.h = $(window).innerHeight();

        this.scrollLimit = 0;
        this.status.section.offset[0] = 0;

        if(param.displayType === 'sp' || param.scrollType === 'y'){

            for(let i=0; i<this.$contents.children().length; i++){
                let _$t = this.$contents.children().eq(i);
                this.scrollLimit = this.scrollLimit + _$t.innerHeight();
                switch (i){
                    case 0 :
                        this.status.section.offset[i+1] = _$t.offset().top;
                        break;
                    case 1 :
                        this.status.section.offset[i+1] =  this.h + this.$contents.children().eq(0).innerHeight();
                        break;
                    case 2 :
                        this.status.section.offset[i+1] =  this.h + this.$contents.children().eq(0).innerHeight() + this.$contents.children().eq(1).innerHeight();
                        break;
                    case 3 :
                        this.status.section.offset[i+1] =  this.h + this.$contents.children().eq(0).innerHeight() + this.$contents.children().eq(1).innerHeight() + this.$contents.children().eq(2).innerHeight();
                        break;
                }

            }
            if(pageID === 'top'){
                this.$contents.css({"height":this.scrollLimit+this.$kv.innerHeight()});
                this.$root.css({"height":this.scrollLimit+this.$kv.innerHeight()});
            }else{
                this.$contents.css({"height":this.scrollLimit+this.$footer.innerHeight()});
                this.$root.css({"height":this.scrollLimit+this.$footer.innerHeight()});
            }
            this.$root.css({"width":"100vw"});
            this.$contents.css({"width":"100vw"});

        }else{

            for(let i=0; i<this.$contents.children().length; i++){
                let _$t = this.$contents.children().eq(i);
                this.scrollLimit = this.scrollLimit + _$t.innerWidth();
                switch (i){
                    case 0 :
                        this.status.section.offset[i+1] = _$t.offset().left;
                        break;
                    case 1 :
                        this.status.section.offset[i+1] =  this.w + this.$contents.children().eq(0).innerWidth();
                        break;
                    case 2 :
                        this.status.section.offset[i+1] =  this.w + this.$contents.children().eq(0).innerWidth() + this.$contents.children().eq(1).innerWidth();
                        break;
                    case 3 :
                        this.status.section.offset[i+1] =  this.w + this.$contents.children().eq(0).innerWidth() + this.$contents.children().eq(1).innerWidth() + this.$contents.children().eq(2).innerWidth();
                        break;
                }
            }

            if(Useragnt.pc)
                this.$root.css({"height":this.scrollLimit+this.$kv.innerWidth()});
            else
                this.$root.css({"width":this.scrollLimit+this.$kv.innerWidth()});

            this.$contents.css({"width":this.scrollLimit+this.$kv.innerWidth()});

        }

        this.pararax.resize(this.w,this.h,this.inc);
        scrollAnimation.resize(this.w,this.h,this.inc);
        contents.resize(this.w,this.h,param.displayType,this.inc);
    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        if(this.status.comp) return;
        this.status.comp = true;
        this.nowInc = this.inc;



    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}